import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
// import data from '../mock/siemens_data_updated.json';
import './GroupIdSelector.css';

function GroupIdSelector({ setValue, setGroupId, groupId, setSelectedRows, data }) {
  let columns = Object.keys(data[0]).map((key) => ({
    field: key,
    headerName: key.replace(/_/g, ' ').toUpperCase(),
    width: 200,
  }));

  columns = [
    {
      field: 'group_id',
      headerName: 'GROUP ID',
      width: 200,
    },
    ...columns.filter((column) => column.field !== 'group_id' && column.field !== 'failed_rule_json'),
  ];

  function handleRowClick(params) {
    // const newSelectedRows = [...selectedRows];
    // newSelectedRows.push({
    //   group_id: `${params.row.group_id}`,
    //   id: `${params.row.id}`,
    // });

    // setSelectedRows(newSelectedRows);
    console.log({ params });
    setGroupId(`${params.row.group_id}`);
    setSelectedRows(params.row);
    // alert(`Group ID: ${params.row.group_id}`);
    // You can call your function here with params.row.group_id
  }

  return (
    <div
      style={{
        padding: '16px',
      }}
    >
      <DataGrid
        rows={data}
        columns={columns}
        {...(data.some((row) => row.group_id) && { getRowId: (row) => row.group_id })}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 7 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
        onRowClick={handleRowClick}
      />

      <Button
        variant="contained"
        sx={{
          backgroundColor: '#00043C',
          '&:hover': { backgroundColor: '#00043C' },
          marginTop: '22px',
        }}
        onClick={() => setValue(2)}
        disabled={`${groupId}` === ''}
      >
        Resolve
      </Button>
    </div>
  );
}

export default GroupIdSelector;
